import React from "react";
import styles from "./CircularProgressBar.module.scss";
interface CircularProgressBarProps {
  radius: number;
  progress: number;
  outerCircleColor?: string;
  innerCircleColor?: string;
  strokeWidth?: number;
  text?: string;
}

const CircularProgress = ({
  radius,
  progress,
  outerCircleColor = "#e3d8fe",
  innerCircleColor = "#b18bfd",
  strokeWidth = 7,
  text,
}: CircularProgressBarProps) => {
  // Calculate the circumference based on the radius
  const circumference = 2 * Math.PI * radius;
  // Calculate the stroke-dashoffset to represent the progress
  const strokeDashoffset = circumference * ((100 - progress) / 100);

  return (
    <div className={styles.progressWrapper}>
      <svg
        width={radius * 2}
        height={radius * 2}
        viewBox={`0 0 ${radius * 2.5} ${radius * 2.5}`}
        style={{ transform: "rotate(-90deg)" }}
      >
        <circle
          r={radius}
          cx={radius + 10}
          cy={radius + 10}
          fill="transparent"
          stroke={outerCircleColor}
          strokeWidth={`${strokeWidth}px`}
        ></circle>
        <circle
          r={radius}
          cx={radius + 10}
          cy={radius + 10}
          fill="transparent"
          stroke={innerCircleColor}
          strokeLinecap="round"
          strokeWidth={`${strokeWidth}px`}
          strokeDasharray={circumference}
          strokeDashoffset={strokeDashoffset}
        ></circle>
      </svg>
      <p
        className={styles.text}
        style={{ color: innerCircleColor, fontSize: radius / 2 }}
      >
        {text}
      </p>
    </div>
  );
};

export default CircularProgress;
